// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container{max-width:1080px;margin:0 auto}.flex{display:flex;flex-wrap:wrap;flex-direction:row;align-items:center}\n", ""]);
// Exports
module.exports = exports;
